import { createBrowserHistory } from 'history';

let history;

export const createHistory = (params, historyProps) => {
  history = historyProps || createBrowserHistory(params);
  return history;
};

export const moveToMainPage = (params?) => history.push('/', params);

export const moveToInvitePage = (params?) => history.push('/invite', params);
